import { formatShortDayDate } from "@redotech/redo-web/time";

import type { OutboundRateOption } from "./util";

export const getEstimatedDeliveryText = (
  option: OutboundRateOption | string | null,
) => {
  if (typeof option === "string" || !option?.estimatedDeliveryDate) {
    return "";
  }
  const estimatedDeliveryDate = Temporal.PlainDate.from(
    option.estimatedDeliveryDate,
  );
  return `Est. delivery ${formatShortDayDate(estimatedDeliveryDate)}`;
};

export const getDeliveryText = (option: OutboundRateOption | string | null) => {
  if (typeof option === "string" || !option) {
    return "";
  }
  const days = option.transitDays ?? option.deliveryDays;
  if (!days) {
    return "";
  }
  return `Est. transit ${days} day${days === "1" ? "" : "s"}`;
};
